

export default {
  borderBottom: "1px solid grey",
  lightBlueColor: "#5DC7FF",
  boxBorder: "1px solid #e6e6e6",
  check: "1px solid red",
  borderRadius:"24px",
  bgColor: "#f6f9fc",
  deskFontSize: "16px",
  mobileFontSize: "11px",
  deskBigFontSize:"60px",
  mobileBigFontSize:"40px",
  greenColor:"#33CF5B",
  blueColor: "#3897f0",
  cloudyColor: `grey`,
  lightCloudColor:"#FFFFFF",
  unCheckBlack: "rgba(0, 0, 0, 0.1)",
  desk_dark_boxBorder:`
    border:3px solid #909090;
  `,
  mobile_dark_boxBorder:`
    border:2px solid #909090;
  `,
  desk_checked_boxBorder:`
  border:3px solid #3897f0;
  `,
  mobile_checked_boxBorder: `
  border:2px solid #3897f0;
  `,
  deskSearchInputBox: `
    border:1px solid #dfe1e5;
    border-radius:24px;
    height:0px;
    background-color:inherit;
    min-width: 30%;
    height: 60px;
    font-size: 16px;
    padding: 0px 20px;
    &:focus {
        outline: none;
    }
    &:hover{
        box-shadow:0 1px 6px 0 rgba(32,33,36,0.28)
    }
  `,
  mobileSearchInputBox: `
    border:1px solid #dfe1e5;
    border-radius:24px;
    height:0px;
    background-color:inherit;
    width: 85%;
    height: 60px;
    font-size: 11px;
    padding: 0px 20px;
    &:focus {
        outline: none;
    }
    &:hover{
        box-shadow:0 1px 6px 0 rgba(32,33,36,0.28)
    }
  `,
};